/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createStagingAllotmentFromDiscriminatorValue, type ProblemDetails, type StagingAllotment } from '../models/index.js';
// @ts-ignore
import { CreateCsvRequestBuilderRequestsMetadata, type CreateCsvRequestBuilder } from './createCsv/index.js';
// @ts-ignore
import { CreateFromCsvRequestBuilderRequestsMetadata, type CreateFromCsvRequestBuilder } from './createFromCsv/index.js';
// @ts-ignore
import { InsertSelectedAllotmentsRequestBuilderRequestsMetadata, type InsertSelectedAllotmentsRequestBuilder } from './insertSelectedAllotments/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /StagingAllotment
 */
export interface StagingAllotmentRequestBuilder extends BaseRequestBuilder<StagingAllotmentRequestBuilder> {
    /**
     * The CreateCsv property
     */
    get createCsv(): CreateCsvRequestBuilder;
    /**
     * The CreateFromCsv property
     */
    get createFromCsv(): CreateFromCsvRequestBuilder;
    /**
     * The InsertSelectedAllotments property
     */
    get insertSelectedAllotments(): InsertSelectedAllotmentsRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<StagingAllotment[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<StagingAllotment[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const StagingAllotmentRequestBuilderUriTemplate = "{+baseurl}/StagingAllotment";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const StagingAllotmentRequestBuilderNavigationMetadata: Record<Exclude<keyof StagingAllotmentRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    createCsv: {
        requestsMetadata: CreateCsvRequestBuilderRequestsMetadata,
    },
    createFromCsv: {
        requestsMetadata: CreateFromCsvRequestBuilderRequestsMetadata,
    },
    insertSelectedAllotments: {
        requestsMetadata: InsertSelectedAllotmentsRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const StagingAllotmentRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: StagingAllotmentRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createStagingAllotmentFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
